<template>
  <ViewCollectedData class="pop-up" v-if="showPopup" @close="close()" />
  <SendDataConformationPopup class="pop-up" v-if="showConfirmation" @close="close()" />
  <DataPrinciples class="pop-up" v-if="showDataPrinciples" @close="close()" />

  <div style="min-width: 1327px;">
    <div class="container">
      <div :class="showPopup || showConfirmation || showDataPrinciples ? 'active-blur' : ''" class="question-container">

        <!-- Header -->
        <div class="disclaimer-container ">
          <h2 class="category" style="padding-bottom: 2rem;"> {{ $t('send_results.description') }}</h2>


          <div class="info-container" @click="showDataPrinciples = true">
            <div class="info-container">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 576 512">
                <path
                  d="M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384v47l-92.8 37.1c-21.3 8.5-35.2 29.1-35.2 52c0 56.6 18.9 148 94.2 208.3c-9 4.8-19.3 7.6-30.2 7.6H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zm39.1 97.7c5.7-2.3 12.1-2.3 17.8 0l120 48C570 277.4 576 286.2 576 296c0 63.3-25.9 168.8-134.8 214.2c-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48zM527.4 312L432 273.8V461.7c68.2-33 91.5-99 95.4-149.7z" />
              </svg>
            </div>
            {{ $t('send_results.more_info') }}
          </div>
        </div>


        <!-- Form -->
        <div class="collected-info-container">
          <div class="collected-info-container">
            <div>{{ $t('send_results.email') }}</div>
            <div><input type="text" id="email" v-model="collected.email"></div>

            <div>{{ $t('send_results.role') }}</div>
            <select v-model="collected.role">
              <option v-for="i in roleList" :key="i" :value="i.val">{{ $t(i.translation) }}</option>
            </select>
            <div v-if="collected.role === 'other'">{{ $t('send_results.other_role') }}</div>
            <div v-if="collected.role === 'other'"><input type="text" v-model="roleInput"></div>

            <div>{{ $t('send_results.org_name') }}</div>
            <div><input type="text" v-model="collected.org_name"></div>

            <div>{{ $t('send_results.domain') }}</div>
            <select v-model="collected.domain">
              <option v-for="i in domainList" :key="i" :value="i.val">{{ $t(i.translation) }}</option>
            </select>
            <div v-if="collected.domain === 'other'">{{ $t('send_results.other_domain') }}</div>
            <div v-if="collected.domain === 'other'"><input type="text" v-model="domainInput"></div>

            <div>{{ $t('send_results.country') }}</div>

            <div class="countries" >
              <div><input type="radio" id="estonia" value="Estonia" style="cursor: pointer" v-model="collected.country" />
                <label style="cursor: pointer" for="estonia">{{ $t('send_results.estonia') }}</label>
              </div>

              <div><input style="cursor: pointer" type="radio" id="czech" value="Czech Republic" v-model="collected.country" />
                <label style="cursor: pointer" for="czech">{{ $t('send_results.czech') }}</label>
              </div>

              <div><input style="cursor: pointer" type="radio" id="other" value="other" v-model="collected.country" />
                <label style="cursor: pointer" for="other">{{ $t('send_results.other_country') }}</label>
              </div>
            </div>
            <div v-if="collected.country === 'other'">{{ $t('send_results.other_country_2') }}</div>
              <div v-if="collected.country === 'other'"><input type="text" v-model="countryInput"></div>


            <div>{{ $t('send_results.workplaces') }}</div>
            <select v-model="collected.workplaces">
              <option v-for="i in workplaceList" :key="i" :value="i">{{ i }}</option>
            </select>
          </div>


          <div class="collected-info-container">
            <div>{{ $t('send_results.time_estimate') }}</div>
            <select v-model="collected.hours">
              <option v-for="i in timeList" :key="i" :value="i.val">{{ $t(i.translation) }}</option>
            </select>

            <div class="dropdown" style="cursor: pointer">{{ $t('send_results.it_dep') }}
              <div class="dropdown-content" v-if="validationIssues.length > 0">
                {{ $t('send_results.it_dep_explanation') }}
              </div>
            </div>
            <select v-model="collected.ITdep">
              <option v-for="i in ITdepList" :key="i" :value="i">{{ i }}</option>
            </select>

            <div>{{ $t('send_results.standard') }}</div>
            <div class="standards">
              <div v-for="(i, k) in standardList" :key="k">
                <input style="cursor: pointer" type="checkbox" id="k" :value="i.val" v-model="collected.standard"> {{ $t(i.translation) }}
              </div>
            </div>

            <div v-if="collected.standard.includes('Other')">{{ $t('send_results.other_country') }}</div>
            <div v-if="collected.standard.includes('Other')"><input type="text" v-model="standardInput"></div>



            <div>{{ $t('send_results.feedback') }}</div>
            <div><textarea v-model="collected.feedback" class="text-box" /></div>
          </div>

        </div>

        <!-- Preview -->
        <div class="collected-info-container" style="padding-top: 0; padding-bottom:1rem">
          <div class="info-container" @click="openPopup()">
            <div class="info-container">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-info-circle"
                viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path
                  d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
              </svg>
            </div>
            {{ $t('send_results.info_sent') }}
          </div>
          <div></div>
        </div>

        <!-- Buttons -->
        <div class="footer">
          <div class="navigation-buttons">
            <router-link :to="{ name: 'questionnaire' }">
              <button class="btn btn-outline-dark back" type="submit">
                {{ $t('send_results.back') }}
              </button>
            </router-link>
          </div>

          <router-link :to="{ name: 'results' }">
            <button class="btn btn-outline-dark back" type="submit">
              {{ $t('send_results.refuse') }}
            </button>
          </router-link>

          <div class="navigation-buttons dropdown">
            <button class="btn btn-outline-dark next" type="submit" :disabled="validationIssues.length > 0"
              @click="addResultData()">
              {{ $t('send_results.send') }}
            </button>
            <div class="dropdown-content" v-if="validationIssues.length > 0">
              {{ $t('send_results.validation') }}
              <div v-for="(issue, i) in validationIssues" :key="i">{{ $t(issue) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ViewCollectedData from "@/components/Popups/ViewCollectedData";
import SendDataConformationPopup from "../Popups/SendDataConformationPopup";
import DataPrinciples from "../Popups/DataPrinciples.vue";

export default {
  name: 'SendData',
  components: { ViewCollectedData, SendDataConformationPopup, DataPrinciples },
  data() {
    return {
      validationIssues: ['send_results.role',
        'send_results.org_name',
        'send_results.domain',
        'send_results.workplaces',
        'send_results.time_estimate',
        'send_results.country',
        'send_results.it_dep'
      ],
      showPopup: false,
      showConfirmation: false,
      showDataPrinciples: false,
      collected: {
        hours: null,
        feedback: "",
        email: null,
        org_name: "",
        domain: null,
        workplaces: null,
        standard: [],
        role: null,
        country: null,
        ITdep: null
      },
      roleInput: "",
      domainInput: "",
      countryInput: "",
      standardInput: "",
      workplaceList: ["0...1", "2...9", "10...49", "50...249", "250...1000", "1001..."],
      roleList: [
        {
          "val": "Management",
          "translation": 'send_results.role_list.management'
        }, {
          "val": "Auditor",
          "translation": 'send_results.role_list.auditor'
        },
        {
          "val": "Information security manager /specialist",
          "translation": 'send_results.role_list.info_manager'
        },
        {
          "val": "IT manager",
          "translation": 'send_results.role_list.IT_manager'
        },
        {
          "val": "Network/system administrator",
          "translation": 'send_results.role_list.network'
        },
        {
          "val": "administrative assistant/lawyer/DPO",
          "translation": 'send_results.role_list.admin'
        }, {
          "val": "other",
          "translation": 'send_results.role_list.other'
        }
      ],
      domainList: [
        {
          "val": "Healthcare",
          "translation": 'send_results.domain_list.healthcare'
        },
        {
          "val": "Education",
          "translation": 'send_results.domain_list.education'
        }, {
          "val": "Municipality",
          "translation": 'send_results.domain_list.municipality'
        }, {
          "val": "ICT",
          "translation": 'send_results.domain_list.ICT'
        }, {
          "val": "Non-profit",
          "translation": 'send_results.domain_list.non-profit'
        },
        {
          "val": "Financial",
          "translation": 'send_results.domain_list.finance',
        }, {
          "val": "Digital infrastructure",
          "translation": 'send_results.domain_list.digital_service',
        }, {
          "val": "Energy",
          "translation": 'send_results.domain_list.energy',
        }, {
          "val": "Water and district heating",
          "translation": 'send_results.domain_list.water_heating',
        }, {
          "val": "Transport",
          "translation": 'send_results.domain_list.transport',
        },
        {
          "val": "other",
          "translation": 'send_results.domain_list.other'
        },
        {
          "val": "Public administration",
          "translation": 'send_results.domain_list.public_admin'
        },
        {
          "val": "Space",
          "translation": 'send_results.domain_list.space'
        },
        {
          "val": "Postal and courier services",
          "translation": 'send_results.domain_list.postal'
        },
        {
          "val": "Waste management",
          "translation": 'send_results.domain_list.waste'
        },
        {
          "val": "Manufacture, production and distribution of chemicals",
          "translation": 'send_results.domain_list.chemicals'
        },
        {
          "val": "Production, processing and distribution of food",
          "translation": 'send_results.domain_list.food'
        },
        {
          "val": "Manufacturing",
          "translation": 'send_results.domain_list.manufactoring'
        },
        {
          "val": "Digital providers",
          "translation": 'send_results.domain_list.digi'
        }
        
      ],
      timeList: [
        {
          "val": "Around 30 minutes",
          "translation": 'send_results.time_list.30_minutes'
        },
        {
          "val": "Around 1 hour",
          "translation": 'send_results.time_list.1_hour'
        }, {
          "val": "2 hours",
          "translation": 'send_results.time_list.2_hours'
        }, {
          "val": "2-4 hours",
          "translation": 'send_results.time_list.4_hours'
        }, {
          "val": "4-8 hours",
          "translation": 'send_results.time_list.8_hours'
        }, {
          "val": "More than 1 working day",
          "translation": 'send_results.time_list.workday'
        }
      ],
      ITdepList: ["0","1", "2", "3...5", "6...10", "10...20", "20...30", "30..."],
      standardList: [
        {
          "val": "ISO/IEC 27001",
          "translation": 'send_results.standard_list.ISO'
        }, {
          "val": "CIS Controls",
          "translation": 'send_results.standard_list.CIS'
        }, {
          "val": "KüTS (Estonian)",
          "translation": 'send_results.standard_list.KYTS'
        }, {
          "val": "NIST CSF",
          "translation": 'send_results.standard_list.NIST'
        }, {
          "val": "E-ITS (Estonian)",
          "translation": 'send_results.standard_list.EITS'
        }, {
          "val": "BSI IT Grundshutz (German)",
          "translation": 'send_results.standard_list.BSI'
        }, {
          "val": "Act on cyber security, no. 181/2014 Coll. (Czech)",
          "translation": 'send_results.standard_list.CzechAct'
        }, {
          "val": "Other",
          "translation": 'send_results.other_country'
        }
      ]
    };
  },
  watch: {
    roleInput() {
      //role input
      if (this.collected.role === "other") {
        if (!(/[a-zA-Z]+/.test(this.roleInput) && this.roleInput.length < 100)
        ) {
          if (!this.validationIssues.includes('send_results.other_role')) this.validationIssues.push('send_results.other_role')
        } else {
          this.validationIssues = this.validationIssues.filter(item => item !== 'send_results.other_role')
        }
      }
    },
    domainInput() {
      if (this.collected.domain === "other") {
        if (!(/[a-zA-Z]+/.test(this.domainInput) && this.domainInput.length < 100)
        ) {
          if (!this.validationIssues.includes('send_results.other_domain')) this.validationIssues.push('send_results.other_domain')
        } else {
          this.validationIssues = this.validationIssues.filter(item => item !== 'send_results.other_domain')
        }
      }
    },
    countryInput(){
//country input
if (this.collected.country === "other") {
          if (!(/[a-zA-Z]+/.test(this.countryInput) && this.countryInput.length < 100)
          ) {
            if (!this.validationIssues.includes('send_results.other_country_2')) this.validationIssues.push('send_results.other_country_2')
          } else {
            this.validationIssues = this.validationIssues.filter(item => item !== 'send_results.other_country_2')
          }
        }
    },
    collected: {
      handler() {

        //email
        if (!(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,20}$/.test(this.collected.email) || this.collected.email === null || this.collected.email === '')
        ) {
          if (!this.validationIssues.includes('send_results.email')) this.validationIssues.push('send_results.email')
        } else {
          this.validationIssues = this.validationIssues.filter(item => item !== 'send_results.email')
        }


        //role
        if (!(this.roleList.filter(item => item.val === this.collected.role) && this.collected.role !== null)) {
          if (!this.validationIssues.includes('send_results.role')) this.validationIssues.push('send_results.role')
        } else {
          this.validationIssues = this.validationIssues.filter(item => item !== 'send_results.role')
        }

        if (this.collected.role === "other") {
          if (!(/[a-zA-Z]+/.test(this.roleInput) && this.roleInput.length < 100)
          ) {
            if (!this.validationIssues.includes('send_results.other_role')) this.validationIssues.push('send_results.other_role')
          } else {
            this.validationIssues = this.validationIssues.filter(item => item !== 'send_results.other_role')
          }
        }

        //org name
        if (!(/[a-zA-Z0-9]+/.test(this.collected.org_name) && this.collected.org_name.length < 100)
        ) {
          if (!this.validationIssues.includes('send_results.org_name')) this.validationIssues.push('send_results.org_name')
        } else {
          this.validationIssues = this.validationIssues.filter(item => item !== 'send_results.org_name')
        }

        //domain
        if (!(this.domainList.filter(item => item.val === this.collected.domain) && this.collected.domain !== null)) {
          if (!this.validationIssues.includes('send_results.domain')) this.validationIssues.push('send_results.domain')
        } else {
          this.validationIssues = this.validationIssues.filter(item => item !== 'send_results.domain')
        }

        //domain input
        if (this.collected.domain === "other") {
          if (!(/[a-zA-Z]+/.test(this.domainInput) && this.domainInput.length < 100)
          ) {
            if (!this.validationIssues.includes('send_results.other_domain')) this.validationIssues.push('send_results.other_domain')
          } else {
            this.validationIssues = this.validationIssues.filter(item => item !== 'send_results.other_domain')
          }
        }

        //workplace
        if (!(this.workplaceList.filter(item => item.val === this.collected.workplaces) && this.collected.workplaces !== null)) {
          if (!this.validationIssues.includes('send_results.workplaces')) this.validationIssues.push('send_results.workplaces')
        } else {
          this.validationIssues = this.validationIssues.filter(item => item !== 'send_results.workplaces')
        }

        //it dep
        if (!(this.ITdepList.filter(item => item.val === this.collected.ITdep) && this.collected.ITdep !== null)) {
          if (!this.validationIssues.includes('send_results.it_dep')) this.validationIssues.push('send_results.it_dep')
        } else {
          this.validationIssues = this.validationIssues.filter(item => item !== 'send_results.it_dep')
        }


        //time
        if (!(this.timeList.filter(item => item.val === this.collected.hours) && this.collected.hours !== null)) {
          if (!this.validationIssues.includes('send_results.time_estimate')) this.validationIssues.push('send_results.time_estimate')
        } else {
          this.validationIssues = this.validationIssues.filter(item => item !== 'send_results.time_estimate')
        }

        //feedback
        if (!(/[a-zA-Z0-9@=\-'"]+/.test(this.collected.feedback) && this.collected.feedback.length < 1000 || this.collected.feedback === "")
        ) {
          if (!this.validationIssues.includes('send_results.feedback')) this.validationIssues.push('send_results.feedback')
        } else {
          this.validationIssues = this.validationIssues.filter(item => item !== 'send_results.feedback')
        }

        //country
        if (this.collected.country === null
        ) {
          if (!this.validationIssues.includes('send_results.country')) this.validationIssues.push('send_results.country')
        } else {
          this.validationIssues = this.validationIssues.filter(item => item !== 'send_results.country')
        }

        //country input
        if (this.collected.country === "other") {
          if (!(/[a-zA-Z]+/.test(this.countryInput) && this.countryInput.length < 100)
          ) {
            if (!this.validationIssues.includes('send_results.other_country_2')) this.validationIssues.push('send_results.other_country_2')
          } else {
            this.validationIssues = this.validationIssues.filter(item => item !== 'send_results.other_country_2')
          }
        }

      },
      deep: true
    }
  },
  methods: {
    close() {
      this.showPopup = false;
      this.showConfirmation = false;
      this.showDataPrinciples = false;
    },
    updateValues() {
      this.$store.state.calculatedSummaryData["email"] = this.collected.email;
      this.$store.state.calculatedSummaryData["role"] = this.collected.role;
      if (this.collected.role === "other") {
        this.$store.state.calculatedSummaryData["role_input"] = this.roleInput;
      }
      this.$store.state.calculatedSummaryData["orgname"] = this.collected.org_name;
      this.$store.state.calculatedSummaryData["domain"] = this.collected.domain;
      if (this.collected.domain === "other") {
        this.$store.state.calculatedSummaryData["domain_input"] = this.domainInput;
      }
      this.$store.state.calculatedSummaryData["workplaces"] = this.collected.workplaces;
      this.$store.state.calculatedSummaryData["ITdep"] = this.collected.ITdep;
      this.$store.state.calculatedSummaryData["hours"] = this.collected.hours;
      this.$store.state.calculatedSummaryData["imp_standard"] = this.collected.standard;
      this.$store.state.calculatedSummaryData["feedback"] = this.collected.feedback;
      this.$store.state.calculatedSummaryData["country"] = this.collected.country;
      if (this.collected.country === "other") {
        this.$store.state.calculatedSummaryData["country_input"] = this.countryInput;
      }
      if (this.collected.standard.includes("Other")) {
        this.$store.state.calculatedSummaryData["standard_input"] = this.standardInput;
      }

    },
    openPopup() {
      this.showPopup = true;
      this.updateValues();
    },
    addResultData() {
      this.updateValues();
      this.showConfirmation = true
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>

<style scoped>
.question-container {
  background-color: white;
}



.container {
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 1560px;
}

.disclaimer-container {
  /* 
  display: grid;
  grid-template-columns: 75% auto;
  gap: 2rem;
  */
  padding: 2rem;
  text-align: left;
  padding-bottom: 0;
  width: 80%;
}

.collected-info-container {
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 20px;
  padding: 2rem;
  align-items: flex-start;
  justify-content: left;
  justify-items: left;
  text-align: left;
}

input[type=text],
select {
  width: 350px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  height: 2rem;
  background-color: white;

}

.footer {
  display: grid;
  grid-template-columns: auto auto auto;
  grid-gap: 10px;
  padding-bottom: 2rem;
}

.pop-up {
  align-content: center;
  display: flex
}

.text-box {
  height: 140px;
  width: 450px
}

.info-container {
  padding-right: 1rem;
  align-items: center;
  display: flex;
  cursor: pointer;
  padding-left: 1rem;
}

.standards {
  display: grid;
  grid-template-columns: auto auto;
  column-gap: 30px;
}

.countries {
  display: flex;
  gap: 2rem;

}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 220px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  padding: 15px 20px;
  z-index: 1;
}

.dropdown:hover .dropdown-content {
  display: block;
  margin-top: -230px;
  text-align: left;
}

label {
  padding-left: 10px;
}

select{
  cursor: pointer
}
</style>
